import { apiFetch } from "./client";

export const userApi = {
  register: async (data: any) => {
    return await apiFetch("/users/register/", {
      method: "POST",
      body: JSON.stringify(data),
    });
  },

  login: async (data: any) => {
    return await apiFetch("/users/login/", {
      method: "POST",
      body: JSON.stringify(data),
    });
  },

  verifyEmail: async (data: { token: string }) => {
    return await apiFetch(`/users/verify-email/?token=${data.token}`, {
      method: "POST",
    });
  },

  forgotPassword: async (data: { email: string }) => {
    return await apiFetch("/users/forgot-password/", {
      method: "POST",
      body: JSON.stringify(data),
    });
  },

  resetPassword: async (data: any) => {
    return await apiFetch("/users/reset-password-confirm/", {
      method: "POST",
      body: JSON.stringify(data),
    });
  },

  updateProfile: async (data: any) => {
    return await apiFetch("/users/me/", {
      method: "PUT",
      body: JSON.stringify(data),
    });
  },

  changePassword: async (data: any) => {
    return await apiFetch("/users/change-password/", {
      method: "POST",
      body: JSON.stringify(data),
    });
  },
};
